export const ActionTypes = {
    DEPOSIT: 'DEPOSIT',
    WITHDRAW: 'WITHDRAW',
    GET_CONDOMINIUMS: 'GET_CONDOMINIUMS',
    SET_CONDOMINIUMS: 'GET_CONDOMINIUMS',
    SELECTED_CONDOMINIUM: 'SELECTED_CONDOMINIUM',
    SET_USER: 'SET_USER'
}